var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating"},_vm._l((_vm.maxRating),function(n,index){return _c('svgicon',{key:index,staticClass:"star",class:_vm.bindConditional(index + 1),attrs:{"rating":_vm.rating,"original":true,"name":_vm.bindConditional(index + 1)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }